export function TitleLogo({ height = 25 }: { height?: number }) {
  return (
    <img
      src="https://res.cloudinary.com/dyuuf6gor/image/upload/v1693255293/gifts/mta-logo_bkswne.png"
      alt="Title Logo"
      height={height}
      style={{ display: "block" }}
    />
  );
}
